export const statusWa = [
  {
    name:'Submitted',
    value:'submitted'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Delivered',
    value:'delivered'
  },
  {
    name:'Failed',
    value:'failed'
  },
  {
    name:'Read',
    value:'read'
  },
  {
    name:'Rejected',
    value:'rejected'
  },
]
export const statusSMS = [
  {
    name:'Submitted',
    value:'submitted'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Sent',
    value:'sent'
  },
  {
    name:'Delivered',
    value:'delivered'
  },
]
export const statusSMSOTP = [
  {
    name:'Submitted',
    value:'submitted'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Sent',
    value:'sent'
  },
  {
    name:'Delivered',
    value:'delivered'
  },
  {
    name:'Undelivered',
    value:'undelivered'
  },
  {
    name:'Failed',
    value:'failed'
  }
]
export const statusEmail = [
  {
    name:'Submitted',
    value:'submitted'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Delivered',
    value:'delivered'
  },
  {
    name:'Unsubscribe',
    value:'unsubscribe'
  },
  {
    name:'Failed',
    value:'failed'
  },
  {
    name:'Opened',
    value:'opened'
  },
  {
    name:'Clicked',
    value:'clicked'
  },
]
export const statusCall = [
  {
    name:'Failed',
    value:'failed'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Rna',
    value:'rna'
  },
  {
    name:'Answered',
    value:'answered'
  },
]
export const statusVoiceOTP = [
  {
    name:'Failed',
    value:'failed'
  },
  {
    name:'In Queue',
    value:'in_queue'
  },
  {
    name:'Submitted',
    value:'submitted'
  },
  {
    name:'Success',
    value:'success'
  },
]